import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { trackPageView } from '../services/analyticsService';
import { useKiosk } from '../contexts/KioskContext';
import { clarity } from '../lib/clarity';

/**
 * Analytics Tracker Component
 * Automatically tracks pageviews when route changes
 */
const AnalyticsTracker = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const { isKiosk } = useKiosk();

  useEffect(() => {
    // Track pageview when route changes. `locale` is the app's resolved
    // i18next language (es/en/zh/ja) — not `navigator.language`, which
    // sendEvent() already captures separately and which the site
    // deliberately ignores when choosing a default (see src/i18n/index.js).
    // This is what powers the "active locale distribution" language metric.
    const locale = (i18n.resolvedLanguage || i18n.language || 'es').slice(0, 2);
    // `kiosk` lands in additionalData (JSONB), same as `locale` — powers the
    // "Vistas desde kiosco" column on the artist metrics page.
    trackPageView(location.pathname, {
      search: location.search,
      hash: location.hash,
      locale,
      kiosk: isKiosk,
    });
    // Mirror the same dimension into Clarity so recordings/heatmaps can be
    // filtered by locale too (docs/ui:ux_feature.md §2.2 "more insights").
    clarity.setTag('locale', locale);
  }, [location, i18n.resolvedLanguage, i18n.language, isKiosk]);

  return null; // This component doesn't render anything
};

export default AnalyticsTracker;

